import { Injectable } from '@angular/core';

import { AnalyticsService } from '@shure/cloud/shared/utils/analytics';

import { DeviceManagementAnalyticsEventsDataMap } from './models/analytics.model';

@Injectable({
	providedIn: 'root'
})
export class DeviceManagementAnalyticsService {
	public readonly readyToTrackEvents = this.analyticsService.isMixpanelInitialized;
	constructor(private analyticsService: AnalyticsService) {}

	public sendEvent<T extends keyof DeviceManagementAnalyticsEventsDataMap>(
		event: T,
		data: DeviceManagementAnalyticsEventsDataMap[T]
	): void {
		this.analyticsService.submitToAnalyticsPlatform(event, data);
	}
}
